import React from 'react';
import classNames from "classnames";

import I18n from '../../i18n/Translation';
import { buildTrafficApi } from '../../api/Api';

const TrafficApi = buildTrafficApi();
class TrafficParkingComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            parkings: [],
            districts: [],
            selectedDistrict: I18n.translate("service.traffic.parking.defaultDistrict")
        }
    }

    componentDidMount() {
        TrafficApi.getParkings().then( res => {
            this.setState({
                parkings: res.parkings.concat().sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0)),
                districts: this.getParkingsDistricts(res.parkings)
            })
        });
    }

    componentDidUpdate() {
        window.pymChild && window.pymChild.sendHeight();
    }

    getParkingsDistricts(parkings) {
        const DISTRICTS = [];
        parkings.map((parking) => {
            if(DISTRICTS.indexOf(parking["district"]) === -1) {
                DISTRICTS.push(parking["district"]);
            }
        });
        return DISTRICTS;
    }

    onClick = (e) => {
        window.logAction();
        this.setState({selectedDistrict: e.target.innerText})
    };

    onChangeDistrict = (e) => {
        window.logAction();
        this.setState({selectedDistrict: e.target.value})
    };

    render() {
        return (
            <div className="pure-u-1">
                <h1 className="service-page__title">{I18n.translate("service.traffic.parking.title")}</h1>
                { this.state.parkings.length === 0 ?
                    <div className="no-data-info text-center">{I18n.translate("service.commons.no-data")}</div>
                        :
                    <div className="pure-g traffic-page__parking-district">
                        <div className="pure-u-1">
                            <ul className="traffic-page__parking-district__list">
                                { this.state.districts.map((d) => {
                                    return (
                                        <li
                                            onClick={this.onClick}
                                            key={"district-"+d}
                                            className={ d === this.state.selectedDistrict? "selectedDistrict":null }
                                        >
                                            <span>{d}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                            <select className="traffic-page__parking-district__select" onChange={this.onChangeDistrict} value={this.state.selectedDistrict}>
                                {this.state.districts.map((d) => {
                                    return <option key={"district-"+d} value={d}>{d}</option>
                                })}
                            </select>
                        </div>
                    </div>
                }
                { this.state.parkings.length > 0 ?
                    <table className="traffic-page__table">
                        <thead>
                            <tr>
                                <th width="25%">{I18n.translate("service.traffic.parking.column.carParks")}</th>
                                <th width="15%">{I18n.translate("service.traffic.parking.column.capacity")}</th>
                                <th className="traffic-page__table__column-occupied" width="35%">{I18n.translate("service.traffic.parking.column.occupied")}</th>
                                <th width="15%">{I18n.translate("service.traffic.parking.column.free")}</th>
                                <th className="text-center" width="10%">{I18n.translate("service.traffic.parking.column.trend")}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.parkings.map((parking) => {
                                if(parking.district !== this.state.selectedDistrict) return null;
                                const trendIconsClasses = {
                                    "parkingTrendStable": parking.trend==='STABLE',
                                    "parkingTrendUp": parking.trend==='UP',
                                    "parkingTrendDown": parking.trend==='DOWN'
                                };
                                return (
                                        <tr key={parking.title}>
                                            <td>{parking.title}</td>
                                            <td>
                                                {parking.open ?
                                                    parking.total ? parking.total : I18n.translate("service.traffic.no-data")
                                                    :
                                                    I18n.translate("service.traffic.parking.closed")
                                                }
                                            </td>
                                            <td className="traffic-page__table__column-occupied">
                                                { parking.open && parking.total ?
                                                    <div className="traffic-page__parking-progress progress round">
                                                        <span className="traffic-page__parking-progress__meter" style={{ width: parking.occupationPerc + '%' }}/>
                                                    </div>
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td>
                                                { parking.open && parking.total ?
                                                    <span>{parking.available}</span>
                                                    :
                                                    null
                                                }
                                            </td>
                                            <td className="text-center">
                                                { parking.open && parking.total ?
                                                    <span className={classNames("traffic-page__parking-trend", trendIconsClasses)}/>
                                                    :
                                                    null
                                                }
                                            </td>
                                        </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                    :
                    null
                }
            </div>
        )
    }

}


export default TrafficParkingComponent;



// WEBPACK FOOTER //
// ./js/services/traffic/TrafficParkingComponent.js